import { useDeficiencyReviewService } from "../../../services/deficiency-review.service";
import ActiveWorkers from "./active-workers";

export default function DeficiencyQueue() {
  const { getActiveDeficiencyReviewers, unassignDeficiencyReviewer, unassignAllDeficiencyReviewers } = useDeficiencyReviewService();

  return (
    <ActiveWorkers
      title="Deficiency Queue"
      emptyMessage="No active reviewers"
      getWorkersFn={getActiveDeficiencyReviewers}
      unassignWorkerFn={unassignDeficiencyReviewer}
      unassignAllWorkersFn={unassignAllDeficiencyReviewers}
      supportManagerContext={false}
    />
  );
}
